import React, { createContext, useContext, useMemo } from 'react';
import axios, { AxiosInstance } from 'axios';

import config from '../jsons/config.json';
import { useSessionId } from './SessionId';
import { getApiUrl, getInstalationId } from '../services/CommonFunctions';
import { useStore } from './Store';

const DEFAULT_CONFIG = {
    ...config.axios,
    baseURL: getApiUrl('https', config.axios.baseURL),
    headers: {
        'X-Api-Key': (window as any).stxChatbot.api_key,
        'X-Instalation-Id': getInstalationId()
    }
};
const DEFAULT_INSTANCE = axios.create(DEFAULT_CONFIG);

type contextType = AxiosInstance;

export const AxiosContext = createContext<contextType>(DEFAULT_INSTANCE);

export const useAxios = () => {
    return useContext(AxiosContext);
};

interface IAxiosProps {
    children: any
}

function Axios({ children }: IAxiosProps) {
    const sessionId = useSessionId();
    const { store, setStore } = useStore();

    const instance = useMemo<contextType>(
        () => {
            const instance = axios.create({
                ...DEFAULT_CONFIG,
                headers: {
                    ...DEFAULT_CONFIG.headers,
                    'X-Session-Id': sessionId?.sessionId,
                    'X-Website-Url': window.location.href
                }
            });

            instance.interceptors.response.use(
                // Kód, který se provede pro úspěšné odpovědi
                function (response) {
                    if (response.headers['x-session-id']) sessionId?.setSessionId(response.headers['x-session-id']);
                    if (response.config.url === 'renew') {
                        setStore({
                            ...store,
                            disableFAQ: false,
                            disableRenewButton: false,
                            disableSendButton: false,
                            disableTextInput: false
                        });
                    }

                    return response;
                },
                // Kód, který se provede pro chybné odpovědi
                async function (error) {
                    if (error.response.status === 403) await instance.get('renew');
                    return Promise.reject(error);
                }
            );

            return instance;
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [sessionId?.sessionId, window.location.href]
    );

    return (
        <AxiosContext.Provider value={instance}>
            {children}
        </AxiosContext.Provider>
    );
}

export default Axios;
